import { MockDebug } from '@tino-frontend/mocks'
import { contractCollectingAPIMock } from '@fixtures/apis/contract-collecting'
import billDetailV3WaitingPaymentWithDebit from '@fixtures/apis/bill/detail-v3/waiting-payment-with-debt'
import { REACT_APP_MERCHANT_BFF_API_URL } from 'constants/envs'

const MockDebugCollecting: MockDebug = {
  title: 'Contrato Status',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:id/contract/collecting`,
  method: 'get',
  delay: 0,
  options: [
    {
      id: 'mock-contract-collecting-true',
      title: 'Coleta de maquininha ligada',
      status: 200,
      data: contractCollectingAPIMock.source,
    },
    {
      id: 'mock-contract-collecting-true-0',
      title: 'Coleta de maquininha ligada - 0%',
      status: 200,
      data: contractCollectingAPIMock.build({
        percentage: 0,
      }),
    },
    {
      id: 'mock-contract-collecting-false',
      title: 'Coleta de maquininha desligada',
      status: 200,
      data: contractCollectingAPIMock.build({
        is_collecting: false,
        percentage: 0,
      }),
    },
  ],
}

const MockDebugBillHome: MockDebug = {
  title: 'Próximo pagamento',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v2/company/:id/home-bill`,
  method: 'get',
  delay: 0,
  options: [
    {
      id: 'mock-home-bill-with-debit',
      title: 'Próximo pagamento (com débito)',
      status: 200,
      data: billDetailV3WaitingPaymentWithDebit,
    },
  ],
}

export const MockDebugContract = [MockDebugCollecting, MockDebugBillHome]
